import { AfterViewInit, Directive, ElementRef } from '@angular/core';


/**------------------------------------------------------
 * Focus Element
 * -------------
 * Allows us focus the element once its is rendered into view
 *
 * Theoretical Example:
 * In some cases we need to focus an element as soon as it
 * has been added to the DOM. We can achieve it by using the
 * directive to the element we need to focus
 *
 * Example:
 * --------
 * 	<input ngFocusElement />
 * */
@Directive({
    selector: '[ngFocusElement]',
    standalone: false
})
export class NgFocusElementDirective implements AfterViewInit {

	constructor(
		private element: ElementRef
	) {}

	ngAfterViewInit(): void {
		this.element.nativeElement.focus({ preventScroll: true });
	}
}
